import { render, staticRenderFns } from "./customer-price.vue?vue&type=template&id=9a8052ea&scoped=true&"
import script from "./customer-price.vue?vue&type=script&lang=js&"
export * from "./customer-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8052ea",
  null
  
)

export default component.exports